import { Link } from '@tanstack/react-router';
import { FileQuestion } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@nucleus-commerce/admin-kit/layout';
import { Button } from '@nucleus-commerce/ui/components/button';

/** Unknown guide slug, tag or operation; rendered inside the docs shell. */
export function DocsNotFoundPage() {
  const { t } = useTranslation('docs');
  return (
    <EmptyState
      icon={FileQuestion}
      title={t('notFound.title')}
      description={t('notFound.description')}
      className="mx-auto mt-10 max-w-xl"
      action={
        <Button asChild>
          <Link to="/docs/api">{t('notFound.action')}</Link>
        </Button>
      }
    />
  );
}
